export default __webpack_public_path__ + "images/predict-KFcbf.gif";